module.exports = __webpack_public_path__ + "img/DW365-271.1faa2d75.jpg";